// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2MudC","title":"Info_title__3z4co","selects":"Info_selects__3jPkX","requiredAsterisk":"Info_requiredAsterisk__1XfjW"};